import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'
import { Thread } from '@flowwai-frontend/bps-officer-web/graphql'
import { ThreadModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

import { convertGqlThreadTypeToLocalThreadType } from '../../factories/threadMessageFactories'

import { GetThreadsForUserQuery as Query } from './query.generatedTypes'
import { ResponseType } from './useGetThreadsForUser'

interface ResponseArgsType {
   data: Query

   onHandleError: (
      errorMessage: string,
      data: Query['getThreadsForUser']
   ) => void

   onSuccess?: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => ResponseType | null
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType) => {
      const { getThreadsForUser } = args.data

      switch (getThreadsForUser.__typename) {
         case 'GetThreadsForUserResponseResult': {
            const threads: ThreadModel[] = []
            getThreadsForUser.threads.forEach(thread => {
               if (thread) {
                  const formattedThreadData = convertGqlThreadTypeToLocalThreadType(
                     thread as Thread
                  )
                  const threadModel = ThreadModel.create(formattedThreadData)
                  threads.push(threadModel)
               }
            })
            return { threads, totalCount: getThreadsForUser.totalCount }
         }
         case 'InvalidLimit':
         case 'InvalidOffset':
         default: {
            const errorType = getThreadsForUser.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onHandleError?.(errorMessage, getThreadsForUser)
            return null
         }
      }
   }

   return { handleAPIResponse }
}

export default useAPIResponseHandler
